import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {

  constructor(private readonly http: HttpClient) { }

  getCommentsForTenant(clientId: string) {
    return this.http.get<TenantComment[]>(`api/tenant/comments?clientId=${clientId}`)
    .pipe(
      map(comments => {
        comments.forEach(c => {
          c.CommentDate = new Date(c.CommentDate + 'Z')
        })
        return comments;
      })
    );
  }

  submitComment(clientId: string, comment: string) {
    return this.http.post(`api/tenant/comments?clientId=${clientId}`, {CommentText: comment});
  }

  deleteComment(comment: TenantComment) {
    return this.http.delete(`api/tenant/comments/${comment.CommentId}`);
  }
}

export class TenantComment{
  Author: string;
  CommentId: string;
  CommentDate: Date;
  CommentText: string;
  CanDelete: boolean;
}
